<div *ngIf="billingData">
  <div *ngIf="billingData.billMechCode != null">
    <ng-container *ngIf="isGenericBilling">
      <div class="flex flex-row align-items-center gap-2">
        <i class="text-xl pi pi-receipt"></i>
        <p class="text-slate-600"> ******** </p>
      </div>
    </ng-container>

    <ng-container *ngIf="isPaymentech && billingData.creditCardNumber">
      <div class="flex flex-row align-items-center gap-2 flex-wrap sm:flex-nowrap">
        <img class="h-2rem" [src]="getCardTypeImage(billingData.creditCardTypeCode)">
        <p class="text-slate-600 white-space-nowrap m-0">{{formattedCardNumber}}</p>
        <p class="text-slate-600 white-space-nowrap m-0">Exp {{billingData.creditCardExpMonth | number:'2.0-0'}}/{{ (billingData.creditCardExpYear % 100) | number:'2.0-0' }}</p>
      </div>
    </ng-container>

    <ng-container *ngIf="isAchAuto && billingData.bankAcctNumber">
      <div class="flex flex-row align-items-center gap-2 flex-wrap sm:flex-nowrap">
        <i class="pi pi-building-columns text-xl"></i>
        <p class="text-slate-600 white-space-nowrap m-0">{{formattedBankAccountNumber}}</p>
      </div>
    </ng-container>
  </div>
</div>
